var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOverdueIcon = function SvgOverdueIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#A764C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23C14.45 23 13.9792 22.8259 13.5875 22.4778C13.1958 22.1296 13 21.7111 13 21.2222C13 20.7333 13.1958 20.3148 13.5875 19.9667C13.9792 19.6185 14.45 19.4444 15 19.4444C15.55 19.4444 16.0208 19.6185 16.4125 19.9667C16.8042 20.3148 17 20.7333 17 21.2222C17 21.7111 16.8042 22.1296 16.4125 22.4778C16.0208 22.8259 15.55 23 15 23ZM13 17.6667V7H17V17.6667H13Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOverdueIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/overdue-icon.26a5472f.svg";
export { ForwardRef as ReactComponent };